module.exports = __webpack_public_path__ + "static/media/incongnito.039746d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Iconos/incongnito.svg
// module id = 2312
// module chunks = 0